import { createRouter, createWebHistory } from 'vue-router';
import useUserStore from '@/stores/userStore';
import useComponentStore from '@/stores/components';
import useDataStore from '@/stores/data';

// 라우터 설계
const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: {
      requiresAuth: true,
      title: 'dashboard',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/find-id',
    name: 'find id',
    component: () => import('@/views/FindId.vue'),
  },
  {
    path: '/find-password',
    name: 'find password',
    component: () => import('@/views/FindPassword.vue'),
  },
  {
    path: '/change-password',
    name: 'change password',
    component: () => import('@/views/ChangePassword.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: {
      requiresAuth: true,
      title: 'profile',
      layout: 'dashboard-layout',
    },
  },
  // {
  //   path: '/mfa-settings',
  //   name: 'Multi-Factor Authentication',
  //   component: () => import('@/views/MfaSetting.vue'),
  //   meta: {
  //     requiresAuth: true,
  //     title: 'mfaSetting',
  //     layout: 'dashboard-layout',
  //   },
  // },
  {
    path: '/administrators',
    name: 'Administrators Management',
    component: () => import('@/views/AdministratorSettings.vue'),
    meta: {
      requiresAuth: true,
      title: 'administratorsSettings',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/outgoing-calls',
    name: 'Outgoing Phone Management',
    component: () => import('@/views/OutgoingPhone.vue'),
    meta: {
      requiresAuth: true,
      title: 'outgoingPhone',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/outgoing-calls/draggable',
    name: 'Outgoing Phone Management Change list order',
    component: () => import('@/views/OutgoingPhoneChangeListOrder.vue'),
    meta: {
      requiresAuth: true,
      title: 'outgoingPhone',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/kakao-profiles',
    name: 'Kakao Profile Management',
    component: () => import('@/views/KakaoProfile.vue'),
    meta: {
      requiresAuth: true,
      title: 'kakaoProfile',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/kakao-profiles/draggable',
    name: 'Kakao Profile Management Change list order',
    component: () => import('@/views/KakaoProfileChangeListOrder.vue'),
    meta: {
      requiresAuth: true,
      title: 'kakaoProfile',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/rejection-numbers',
    name: 'Reject Phone Management',
    component: () => import('@/views/RejectPhone.vue'),
    meta: {
      requiresAuth: true,
      title: 'rejectPhone',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/rejection-numbers/draggable',
    name: 'Reject Phone Management Change list order',
    component: () => import('@/views/RejectPhoneChangeListOrder.vue'),
    meta: {
      requiresAuth: true,
      title: 'rejectPhone',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/unsubscribe-customers',
    name: 'Unsubscribe Customer Care',
    component: () => import('@/views/RejectPhoneData.vue'),
    meta: {
      requiresAuth: true,
      title: 'unsubscribeCustomer',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/departments',
    name: 'Department Information Management',
    component: () => import('@/views/DepartmentInformation.vue'),
    meta: {
      requiresAuth: true,
      title: 'departmentInformation',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/departments/draggable',
    name: 'Department Information Management Change list order',
    component: () => import('@/views/DepartmentInformationChangeListOrder.vue'),
    meta: {
      requiresAuth: true,
      title: 'departmentInformation',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/charge',
    name: 'Charge',
    component: () => import('@/views/AccountBill.vue'),
    meta: {
      requiresAuth: true,
      title: 'charge',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/message-groups',
    name: 'Message Groups',
    component: () => import('@/views/MessageGroups.vue'),
    meta: {
      requiresAuth: true,
      title: 'messageUsage',
      layout: 'dashboard-layout',
    },
  },
  {
    // version
    path: '/message-groups/:messageGroupId',
    name: 'Message Group Version List',
    component: () => import('@/views/MessageGroupVersions.vue'),
    meta: {
      requiresAuth: true,
      title: 'messageUsage',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/message-groups/:messageGroupId/versions/:version',
    name: 'Message Group Activity List',
    component: () => import('@/views/MessageGroupActivities.vue'),
    meta: {
      requiresAuth: true,
      title: 'messageUsage',
      layout: 'dashboard-layout',
    },
  },
  {
    // activities
    path: '/message-groups/:messageGroupId/versions/:version/activities/:activityId',
    name: 'Message Group Messages',
    component: () => import('@/views/MessageGroupActivityMessages.vue'),
    meta: {
      requiresAuth: true,
      title: 'messageUsage',
      layout: 'dashboard-layout',
    },
  },
  {
    // message-detail
    path: '/messages/:messageId',
    name: 'Message Detail',
    component: () => import('@/views/MessageDetail.vue'),
    meta: {
      requiresAuth: true,
      title: 'messageUsage',
      layout: 'dashboard-layout',
    },
  },
  {
    // 수신자 번호 검색
    path: '/recipient-number',
    name: 'Recipient Number',
    component: () => import('@/views/RecipientNumberSearch.vue'),
    meta: {
      requiresAuth: true,
      title: 'recipientNumber',
      layout: 'dashboard-layout',
    },
  },
  {
    // message-detail
    path: '/recipient-number/messages/:messageId',
    name: 'Recipient Number Message Detail',
    component: () => import('@/views/MessageDetail.vue'),
    meta: {
      requiresAuth: true,
      title: 'messageUsage',
      layout: 'dashboard-layout',
    },
  },
  {
    // Activity 검색
    path: '/activity-search',
    name: 'Activity Search',
    component: () => import('@/views/ActivitySearch.vue'),
    meta: {
      requiresAuth: true,
      title: 'activitySearch',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/kakao-templates',
    name: 'Kakao Template',
    component: () => import('@/views/KakaoTemplate.vue'),
    meta: {
      requiresAuth: true,
      title: 'kakaoTemplate',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/kakao-templates/:templateId',
    name: 'Kakao Template Management',
    component: () => import('@/views/KakaoTemplateManagement.vue'),
    meta: {
      requiresAuth: true,
      title: 'kakaoTemplate',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/kakao-templates/create-form',
    name: 'Kakao Template create form',
    component: () => import('@/views/KakaoTemplateCreateForm.vue'),
    meta: {
      requiresAuth: true,
      title: 'kakaoTemplate',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/images',
    name: 'images',
    component: () => import('@/views/ImagesView.vue'),
    meta: {
      requiresAuth: true,
      title: 'images',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/views/TermsView.vue'),
    meta: {
      requiresAuth: true,
      title: 'terms',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/PrivacyView.vue'),
    meta: {
      requiresAuth: true,
      title: 'privacy',
      layout: 'dashboard-layout',
    },
  },
  {
    path: '/privacy2',
    name: 'Privacy2',
    component: () => import('@/views/PrivacyView2.vue'),
    meta: {
      requiresAuth: false,
      title: 'privacy2',
    },
  },
  {
    path: '/terms2',
    name: 'terms2',
    component: () => import('@/views/TermsView2.vue'),
    meta: {
      requiresAuth: false,
      title: 'terms2',
    },
  },
];

// 라우터 생성
const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // const tableCount = document.querySelector('.board');
    if (savedPosition) {
      return savedPosition;
    }

    if (to.path === from.path) {
      return null;
    }

    return {
      top: 0,
      left: 0,
    };
  },
});

const userStoreInitCheck = () => new Promise((resolve, reject) => {
  const timeout = Date.now() + 1000 * 15;
  const { state } = useUserStore();

  if (state?.init) {
    resolve();
    return;
  }

  const check = () => {
    const store = useUserStore();

    if (timeout < Date.now()) {
      reject(new Error('init check timeout'));
      window.location.reload();
      return;
    }

    if (store?.state?.init) {
      resolve();
      return;
    }

    setTimeout(check, 100);
  };

  setTimeout(check, 50);
});

router.beforeEach(async (to, _, next) => {
  await userStoreInitCheck();

  const { state } = useUserStore();
  const { resetOrganizationInfo } = useDataStore();
  const {
    openAlertDialog,
    openMfaAuth,
    openTemporaryPasswordChange,
  } = useComponentStore();

  if (to.meta.requiresAuth) {
    if (state.tokenExpired) {
      await openAlertDialog({
        title: 'common.alert.expired.title',
        titleClass: 'certificationPop',
        content: 'common.alert.expired.content',
      }).promise;

      next({
        path: '/login',
        query: {
          state: to.fullPath,
        },
      });
      return;
    }

    if (!state.accessToken) {
      await openAlertDialog({
        title: 'common.alert.needLogin.title',
        titleClass: 'certificationPop',
        content: 'common.alert.needLogin.content',
      }).promise;

      next({
        path: '/login',
        query: {
          state: to.fullPath,
        },
      });
      return;
    }
  }

  if (!state.status) {
    next();
    return;
  }

  if (![
    'find id',
    'Login',
    'find password',
  ].includes(to.name)) {
    if (state.status === 'MFA') {
      const result = await openMfaAuth({});

      if (!result) {
        next({
          path: '/login',
          query: {
            state: to.fullPath,
          },
        });
        return;
      }

      resetOrganizationInfo();
    }

    if (state.status === 'TEMPORARY_PASSWORD') {
      const result = await openTemporaryPasswordChange({});

      if (!result) {
        next({
          path: '/login',
          query: {
            state: to.fullPath,
          },
        });
        return;
      }

      resetOrganizationInfo();
    }
  }

  next();
});

export default router;
